import { tracking } from '@iwoca/frontend-tracking-library';
import { Link } from '@iwoca/orion';

export const PriceCheckModalContentDE = () => {
    return (
        <div className="flex flex-col justify-center">
            <div className="text-left text-s font-reg">
                <p>
                    Unsere Preise spiegeln die Vielseitigkeit unserer
                    Finanzierungslösungen und die unterschiedlichen Bedürfnisse
                    der Unternehmen wider, die wir unterstützen. Doch wir
                    möchten sicherstellen, dass Sie die bestmögliche
                    Finanzierung erhalten.
                </p>
                <p>
                    Falls Ihnen ein besseres Angebot vorliegt, lassen Sie es uns
                    wissen! Gerne prüfen wir, ob wir unser Angebot für Sie
                    anpassen können. Senden Sie uns einfach ein paar Details zu
                    Ihrem vorliegenden Angebot:
                </p>
                <ul className="ml-xl list-disc">
                    <li>Name des Anbieters</li>
                    <li>Laufzeit</li>
                    <li>Genehmigte Kreditsumme</li>
                    <li>
                        Jährlicher Zinssatz sowie eventuell anfallende Gebühren
                        (z.B. Festgebühr oder Vor­fälligkeits­entschädigung)
                    </li>
                    <li>Benötigte Sicherheiten (inklusive Versicherungen)</li>
                    <li>Vorzeitige Rückzahlungmodalitäten</li>
                </ul>
                <p>
                    Bitte senden Sie uns neben den oben genannten Details noch
                    einen kurzen Nachweis zu Ihrem Angebot. Daraus sollte
                    erkennbar sein, dass sich das Angebot an Sie richtet und
                    aktuell ist.
                </p>
                <p>
                    Nach Erhalt und Prüfung der Informationen, melden wir uns
                    innerhalb von 24 Stunden mit einem aktualisierten Angebot
                    bei Ihnen.
                </p>
                <p>
                    Wir freuen uns darauf, Sie und Ihr Unternehmen zu
                    unterstützen!
                </p>
            </div>
            <Link
                size="medium"
                target="blank"
                href="#"
                onClick={() => {
                    tracking.ampli.priceCheckSendEmailClicked();
                    window.open(
                        'mailto:support@iwoca.de?subject=iwoca Kreditangebot - Jetzt Preisnachlass sichern&body='
                    );
                }}
            >
                Senden Sie eine E-Mail an support@iwoca.de
            </Link>
        </div>
    );
};
